import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import { useMutation } from "@tanstack/react-query";
import cn from "classnames";
import { useTranslate } from "../../../../../hooks/useTranslate";
import axiosManager from "../../../../../services/axiosManager";
import "./Signees.css";

const SigneesStatus = (props) => {
    const {
        signees = [], contacts = [], studentId, contractId,
        isManage, isCard, hideReEmail,
    } = props;
    const { t } = useTranslate();

    const signeesFull = contacts
        .filter((contact) => signees.map((item) => item.contactId).includes(contact.contactId))
        .map((contact) => ({
            id: contact.contactId,
            name: contact.displayName,
            status: signees.find((i) => i.contactId === contact.contactId)?.signingStatus,
        }));

    const {
        mutate: reEmailAgreement, reset: resetReEmailAgreement,
        isPending: isReEmailingAgreement, isSuccess: isSuccessReEmailAgreement, error: errorReEmailAgreement,
    } = useMutation({
        mutationFn: () => axiosManager.post$(`/parent/api/students/${studentId}/contracts/${contractId}/resend`, {}),
        onSettled: () => {
            setTimeout(() => {
                resetReEmailAgreement();
            }, 5000);
        },
    });

    return (
        <>
            {isCard ? null : (
                <Typography variant="h5" component="div" className={cn("mt-4", isManage ? "text-white" : "")}>
                    {t("enrolmentAgreement.requiredSigneesStatus")}
                </Typography>
            )}
            <div className={cn("flex", isCard ? "gap-4 flex-column" : "mt-4 gap-6 align-center")}>
                {(signeesFull || []).map((person) => (
                    <span key={person.id} className="signee-item">
                        <span
                            className={`signee-item__icon ${person.status === "Signed" ? "signee-item__icon--check" : ""}`}
                        >
                            {person.status === "Signed" && <DoneIcon />}
                        </span>
                        {`${person.name} - ${t(`enrolmentAgreement.status.${person.status}`)}`}
                    </span>
                ))}
            </div>
            {!hideReEmail && (
                <div className={cn("additional-signee mt-4", isCard ? "additional-signee--full" : "")}>
                    <Button
                        variant="contained"
                        className={cn("re-email-signee__button", isManage ? "button-accent" : "button-primary", isCard ? "w-full" : "")}
                        onClick={reEmailAgreement}
                        loading={isReEmailingAgreement}
                        disabled={isSuccessReEmailAgreement}
                    >
                        {t("enrolmentAgreement.reEmailAgreement")}
                    </Button>
                </div>
            )}
            {isSuccessReEmailAgreement
                && <div className="success-re-email-agreement">{t("enrolmentAgreement.successReEmailAgreement")}</div>}
            {errorReEmailAgreement
                && <div className="error-re-email-agreement">{t("enrolmentAgreement.errorReEmailAgreement")}</div>}
        </>
    );
};

export default SigneesStatus;
